import { Card, Image, Tag, Text, VStack } from '@chakra-ui/react';
import OrganizationPipelineImageMobile from '~/apps/consumer/images/signup/organization-pipeline-mobile.png';
import OrganizationPipelineImage from '~/apps/consumer/images/signup/organization-pipeline.png';
import { useIsMobile } from '~/common/hooks/useIsMobile';

export const OrganizationPipelineComingSoon = () => {
  const isMobile = useIsMobile();

  return (
    <VStack
      alignItems="center"
      gap={4}
      height="100%"
      justifyContent="center"
      p={4}
    >
      <Card alignItems="center" pb={0} pt={10} px={{ base: 0, md: 20 }}>
        <VStack
          alignItems="center"
          gap={4}
          justifyContent="center"
          mb={10}
          px={{ base: 4, md: 0 }}
          width={{ md: '100%', xl: '50%' }}
        >
          <Tag bg="purpleGradient">Coming Soon</Tag>
          <Text
            fontSize={{ base: '32px', md: '50px' }}
            fontWeight="medium"
            lineHeight="1"
            textAlign="center"
          >
            Full visibility into your offers pipeline
          </Text>
          <Text
            color="whiteAlpha.600"
            fontSize={{ base: '18px', md: '24px' }}
            textAlign="center"
          >
            All your contracts in one place, fully automated by connecting your
            contract system.
          </Text>
        </VStack>

        <Image
          mt={{ base: '-200px', md: '-140px', xl: '-200px' }}
          position="relative"
          src={
            isMobile
              ? OrganizationPipelineImageMobile
              : OrganizationPipelineImage
          }
          width="100%"
          zIndex="0"
        />
      </Card>
    </VStack>
  );
};
